
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collezioni/[[...slug]]",
      function () {
        return require("private-next-pages/collezioni/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collezioni/[[...slug]]"])
      });
    }
  